import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { agreementRelationshipManager, type IAgreementRelationship } from '@inpart-io/padme-iap';

import { getSearchModule } from '@/store/base/search/module';

import { store } from '../index';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type AgreementRelationshipType } from './types';

const AGREEMENT_RELATIONSHIP_MODULE = 'agreementRelationshipModule';

const dataObjectModule = getDataObjectsModule<IAgreementRelationship>(agreementRelationshipManager, 3);
const searchModule = getSearchModule<IAgreementRelationship>(agreementRelationshipManager);

const state: AgreementRelationshipType = {
    agreementRelationshipTypes: []
};

const agreementRelationshipModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(AGREEMENT_RELATIONSHIP_MODULE, agreementRelationshipModuleInstance);

export { AGREEMENT_RELATIONSHIP_MODULE };
